module.exports = __webpack_public_path__ + "img/090-burkina-faso.90d57f77.svg";